// The APP LOADER (2026-10-15, user call: "change the global app loader …
// some premium loader"): what the app shows while it has nothing of its
// own to show yet — a returning reader's stored session being re-verified
// on a reload (components/AuthGate), the one-commit hop of a Lab deep
// link, and a route chunk loading cold (navigation/RouterConfig's Suspense
// fallback). Until today that was the PLAIN BOARD's skeleton under its
// own header ("Cultural IQ · Brand leaderboard · GLOBAL · RANKED BY
// CULTURAL IQ"): a mirror of a screen a signed-in reader never lands on
// (the home is the digest), so it promised one layout and delivered
// another — a skeleton earns its place only where it mirrors what arrives.
//
// What it is: the product's mark — the 3.5 disc, the tab icon — centred
// in the viewport on PAPER (every route starts on paper, and the digest
// lands on it, so no ground flashes), with the app's one spinner
// (components/Ring, the wall's ring) turning AROUND it as its border
// (user call 2026-10-15, after a first build with the ring under the
// disc: "put the loading effect around the 3.5 logo like it is its
// border"): the arc, in the disc's own mint, orbits the rim over a faint
// track a few pixels off the disc — the mark is the loader, nothing
// else is on the page. No copy: a loader that names itself is a loader
// that is taking too long. Past
// SLOW_MS a quiet line admits the wait (Nielsen's ten seconds, halved —
// the same beat as the wall's), in a slot held open so the column never
// moves; the request itself gives up at services/authService
// AUTH_TIMEOUT_MS, and a chunk at the network's. A screen reader hears
// the `label` from an sr-only status line, and the slow line after it.
//
// `late` (the Suspense fallback): the loader stays INVISIBLE for
// LATE_MS and fades in only past it — a warm chunk arrives inside that
// window, and a loader that flashes for three frames reads as a glitch
// (the 100ms / 1s thresholds). The verify path shows it from the first
// frame instead: the server paces every auth answer to 0.3s at least
// (apps/api modules/auth), so a reload always waits long enough to see
// it. The hand-off is a view transition (contexts/SessionContext): the
// loader dissolves while the home rises, never a cut.
import { useEffect, useState } from "react";

import Ring from "components/Ring";
import { LOGO_SRC } from "components/Wordmark";

export const LOADING = "Loading";
export const OPENING_WORKSPACE = "Opening your workspace";
export const SLOW_LINE = "Taking longer than usual.";

// when the wait admits it is long; how long a late loader stays unseen
// (the CSS mirrors LATE_MS — `.app-loader.late`'s animation delay)
export const SLOW_MS = 4000;
export const LATE_MS = 240;

export default function AppLoader({ label = LOADING, late = false }) {
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setSlow(true), SLOW_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`app-loader${late ? " late" : ""}`} aria-busy="true">
      {/* the badge: the disc with the ring laid over its rim (the badge
          box is the disc's; the ring bleeds past it, positioned off it) */}
      <span className="app-loader-badge">
        {/* the file is 664px square — the attributes hold its box before
            it loads, so the ring is already on its rim */}
        <img
          className="app-loader-mark"
          src={LOGO_SRC}
          alt=""
          width="664"
          height="664"
          draggable={false}
        />
        <Ring className="app-loader-ring" on />
      </span>
      <p
        className={`app-loader-line${slow ? " shown" : ""}`}
        aria-hidden="true"
      >
        {SLOW_LINE}
      </p>
      <p className="sr-only" role="status">
        {slow ? `${label}. ${SLOW_LINE}` : label}
      </p>
    </div>
  );
}
